import {Component} from 'react'
import Cookies from 'js-cookie'
import {Redirect} from 'react-router-dom'
import {BsBriefcaseFill, BsStarFill, BsBoxArrowUpRight} from 'react-icons/bs'
import {MdLocationOn} from 'react-icons/md'
import Loader from 'react-loader-spinner'
import Header from '../Header'
import SimilarJobs from '../SimilarJobs'
import './index.css'

class JobItemDetails extends Component {
  state = {
    jobDetails: null,
    similarJobs: [],
    isLoading: true,
    isApiSuccess: false,
  }

  componentDidMount() {
    this.getJobDetails()
  }

  getJobDetails = async () => {
    const {match} = this.props
    const {id} = match.params
    const jwtToken = Cookies.get('jwt_token')

    const response = await fetch(`https://apis.ccbp.in/jobs/${id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    })

    if (response.ok) {
      const data = await response.json()

      const job = data.job_details

      const updatedJobDetails = {
        id: job.id,
        title: job.title,
        companyLogoUrl: job.company_logo_url,
        companyWebsiteUrl: job.company_website_url,
        employmentType: job.employment_type,
        jobDescription: job.job_description,
        location: job.location,
        packagePerAnnum: job.package_per_annum,
        rating: job.rating,
        skills: job.skills.map(each => ({
          name: each.name,
          imageUrl: each.image_url,
        })),
        lifeAtCompany: {
          description: job.life_at_company.description,
          imageUrl: job.life_at_company.image_url,
        },
      }

      const updatedSimilarJobs = data.similar_jobs.map(each => ({
        id: each.id,
        title: each.title,
        companyLogoUrl: each.company_logo_url,
        jobDescription: each.job_description,
        rating: each.rating,
        location: each.location,
        employmentType: each.employment_type,
      }))

      this.setState({
        jobDetails: updatedJobDetails,
        similarJobs: updatedSimilarJobs,
        isLoading: false,
        isApiSuccess: true,
      })
    } else {
      this.setState({isLoading: false, isApiSuccess: false})
    }
  }

  renderJobSuccess = () => {
    const {jobDetails, similarJobs} = this.state

    return (
      <div className="job-item-details-bg">
        <div className="job-card">
          <div className="job-header">
            <img
              src={jobDetails.companyLogoUrl}
              alt="job details company logo"
              className="company-logo"
            />

            <div>
              <h4 className="job-title">{jobDetails.title}</h4>

              <div className="rating-container">
                <BsStarFill className="star-icon" />
                <p>{jobDetails.rating}</p>
              </div>
            </div>
          </div>
          <div className="job-info-row">
            <div className="info-left">
              <div className="info-item">
                <MdLocationOn className="info-icon" />
                <p>{jobDetails.location}</p>
              </div>

              <div className="info-item">
                <BsBriefcaseFill className="bag-icon" />
                <p>{jobDetails.employmentType}</p>
              </div>
            </div>

            <p className="package">{jobDetails.packagePerAnnum}</p>
          </div>

          <hr />
          <div className="desc-header">
            <h4 className="section-title">Description</h4>

            <a
              href={jobDetails.companyWebsiteUrl}
              target="_blank"
              rel="noreferrer"
              className="visit-link"
            >
              Visit <BsBoxArrowUpRight />
            </a>
          </div>

          <p className="description-text">{jobDetails.jobDescription}</p>

          <h3 className="section-title">Skills</h3>

          <ul className="skills-list">
            {jobDetails.skills.map(skill => (
              <li className="skill-item" key={skill.name}>
                <img
                  src={skill.imageUrl}
                  alt={skill.name}
                  className="skill-img"
                />
                <p>{skill.name}</p>
              </li>
            ))}
          </ul>

          <h4 className="section-title">Life at Company</h4>

          <div className="life-container">
            <p className="life-text">{jobDetails.lifeAtCompany.description}</p>
            <img
              src={jobDetails.lifeAtCompany.imageUrl}
              alt="life at company"
              className="life-img"
            />
          </div>
        </div>
        <h2 className="similar-section-title">Similar Jobs</h2>

        <ul className="similar-list">
          {similarJobs.map(each => (
            <SimilarJobs key={each.id} similarJobs={each} />
          ))}
        </ul>
      </div>
    )
  }

  renderJobFailure = () => (
    <div className="failure-view">
      <img
        src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
        alt="failure view"
        className="failure-img"
      />
      <h1>Oops! Something Went Wrong</h1>
      <p>We cannot seem to find the page you are looking for.</p>
      <button className="retry-btn" onClick={this.getJobDetails}>
        Retry
      </button>
    </div>
  )

  renderLoader = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  renderContent = () => {
    const {isLoading, isApiSuccess} = this.state

    if (isLoading) {
      return this.renderLoader()
    }

    if (isApiSuccess) {
      return this.renderJobSuccess()
    }

    return this.renderJobFailure()
  }

  render() {
    const jwtToken = Cookies.get('jwt_token')
    if (!jwtToken) {
      return <Redirect to="/login" />
    }
    return (
      <>
        <Header />
        {this.renderContent()}
      </>
    )
  }
}

export default JobItemDetails
